import {
    Component,
    ChangeDetectionStrategy,
    inject,
    signal,
    computed,
    input,
} from '@angular/core'
import { RouterModule } from '@angular/router'
import { AuthStateService } from '@mattrika/benefit-core'
import { NgIcon } from '@ng-icons/core'

@Component({
    selector: 'app-header-profile-menu',
    imports: [RouterModule, NgIcon],
    templateUrl: './header-profile-menu.component.html',
    styleUrl: './header-profile-menu.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderProfileMenuComponent {
    userName = input<string>('')
    userRole = input<string>('')
    userEmail = input<string>('')
    isOwner = input<boolean | undefined>(undefined)

    readonly auth = inject(AuthStateService)
    readonly isVisibleDropDown = signal<boolean>(false)

    readonly effectiveIsOwner = computed<boolean>(() => {
        const customOwner = this.isOwner()
        if (customOwner !== undefined) return customOwner
        return this.auth.isOwnerSignal()
    })

    readonly displayRole = computed<'Admin' | 'Vendor' | 'Client'>(() => {
        const customRole = this.userRole()?.trim().toLowerCase()
        if (customRole === 'admin') return 'Admin'
        if (customRole === 'vendor') return 'Vendor'
        if (customRole === 'client') return 'Client'
        return this.auth.userRoleSignal()
    })

    readonly displayEmail = computed(
        () => this.userEmail() || this.auth.userEmailSignal() || '',
    )

    readonly displayName = computed(
        () =>
            this.userName() || this.auth.userNameSignal() || this.displayRole(),
    )

    readonly displayInitials = computed(() => {
        const name = this.userName()?.trim()
        if (name) {
            const parts = name.split(/\s+/)
            if (parts.length >= 2) {
                return (parts[0][0] + parts[1][0]).toUpperCase()
            }
            if (name.length >= 2) {
                return name.slice(0, 2).toUpperCase()
            }
        }
        return this.auth.userInitialsSignal()
    })

    readonly isLoggedIn = computed(() => this.auth.isLoggedInSignal())

    readonly showClientDashboard = computed(
        () =>
            this.isLoggedIn() &&
            this.displayRole() === 'Client' &&
            !this.effectiveIsOwner(),
    )

    toggleDropDown() {
        this.isVisibleDropDown.update((open) => !open)
    }

    closeDropDown() {
        this.isVisibleDropDown.set(false)
    }

    logout() {
        this.closeDropDown()
        this.auth.logout('/login')
    }
}
